export enum PbxStatus {
  GLOBAL = 'GLOBAL',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE'
}
